<div class="implementationControlStatement-component" style="margin: 0 20px;">
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div>

    </div>

    <div style="display: flex; flex-direction: row; margin: 16px 0 20px 0; align-items:center;" *ngIf="isEditable">
      <button mat-raised-button
              (click)="editSet(null)"
              style="border-radius: 6px;margin-right: 10px; "
              class="button">
        Create
      </button>

    </div>
  </div>
  <div style="display: flex; flex-direction: row; gap: 40px;">
    <div style="width: 100%;">
      <p-table [value]="implementationControlStatementSets"
               *ngIf="implementationControlStatementSets"
               rowGroupMode="subheader"
               dataKey="id">
        >
        <ng-template pTemplate="body" let-set let-expanded="expanded">
          <tr [pRowToggler]="set">
            <td style="width: 10em;">
              <a>
                <i [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
              </a>
            </td>
            <td>{{ set.name }}</td>
            <td style="width: 10em;">
              <i class="pi pi-pencil cursor-pointer" (click)="editSet(set)"></i>
              <i class="pi pi-trash cursor-pointer" (click)="deleteSet(set)"></i>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="expandedrow" let-set let-rowIndex="rowIndex" let-expanded="expanded">
          <tr>
            <td colspan="3">
              <div style="display: flex; flex-direction: row; margin: 16px 0 20px 0; align-items:center;" *ngIf="isEditable">
                <button mat-raised-button
                        (click)="add(set)"
                        style="border-radius: 6px;margin-right: 10px; "
                        class="button">
                  Create
                </button>

                <button mat-raised-button
                        (click)="inputFile.click()"
                        matTooltip="{{this.constants.ATTACHMENT_FILE_DESCRIPTION}}">
                  <i class="pi pi-paperclip"></i>
                  Upload Items
                </button>
                <input #inputFile
                       type="file"
                       accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                       (change)="uploadItems($event, set)"
                       [style.display]="'none'">

              </div>
            </td>
          </tr>
          <tr>
            <td colspan="3">
              <p-table [value]="set.implementationControlStatements" [(selection)]="set.selectedItems"
                       *ngIf="set.implementationControlStatementForms && rowGroupMetadata"
                       rowGroupMode="subheader"
                       dataKey="category">
                <ng-template pTemplate="header">
                  <tr style="white-space: nowrap;font-weight: bold">
                    <th style="width:2em;"></th>
                    <th style="width:20%;">Category</th>
                    <th>Implementation Control Statement Name</th>
                    <th style="width:15em"><i class="pi pi-trash" mwlConfirmationPopover
                                              [title]="'Delete Implementation Control Statements'"
                                              [popoverMessage]="'You are going to delete all Implementation Control Statements. Are you sure?'"
                                              [appendToBody]="true"
                                              [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                                              (confirm)="dropAllImplementationControlStatements(set)"></i></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-rowIndex="rowIndex" let-expanded="expanded"
                             let-columns="columns">
                  <tr class="ui-widget-header"
                      *ngIf="rowGroupMetadata[set.id][item.category || ' '].index === rowIndex">
                    <td colspan="3">
                      <a href="#" [pRowToggler]="item">
                        <i
                          [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                        <span>{{ item.category }}</span>
                      </a>
                    </td>
                    <td style="width: 5em;">
                      <i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Implementation Control Statements'"
                         [popoverMessage]="'You are going to delete these implementation Control Statements. Are you sure?'"
                         [appendToBody]="true"
                         [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                         (confirm)="dropImplementationControlStatements(set, item.category)"></i></td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="expandedrow" let-item let-i="rowIndex">
                  <tr>
                    <td style="width:2em;">
                    <span>
                      <i [ngClass]="item.open ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                         (click)="item.open = !item.open"></i>
                    </span>
                    </td>
                    <td>{{ item.category }}</td>
                    <td>{{ item.name }}</td>
                    <td style="width: 5em;">
                      <i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Implementation Control Statement'"
                         [popoverMessage]="'You are going to delete this implementation Control Statement. Are you sure?'"
                         [appendToBody]="true"
                         [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                         (confirm)="dropImplementationControlStatement(item)"></i></td>
                  </tr>
                  <tr *ngIf="item.open">
                    <td colspan="3">

                      <form [formGroup]="set.implementationControlStatementForms[i]" style="width: 100%;">
                        <div>
                          <mat-form-field>
                            <mat-label>Name</mat-label>
                            <input type="text" matInput name="name" formControlName="name">
                          </mat-form-field>
                        </div>
                        <div>
                          <mat-form-field>
                            <mat-label>Category</mat-label>
                            <input type="text" matInput name="category" formControlName="category">
                          </mat-form-field>
                        </div>
                        <mat-checkbox formControlName="view">View</mat-checkbox>
                        <div class="ql-editor"
                             [ngStyle]="{'display': set.implementationControlStatementForms[i].controls.view.value ? 'block' : 'none'}"
                             [innerHTML]="addToken(set.implementationControlStatementForms[i].controls.text.value) | sanitizeHtml"></div>
                        <p-editor
                          [ngStyle]="{'display': set.implementationControlStatementForms[i].controls.view.value ? 'none' : 'block'}"
                          formControlName="text"
                          type="text"
                        >

                          <p-header>
                  <span class="ql-formats">
                    <select class="ql-size">
                      <option value="huge">Heading</option>
                      <option value="large">Subheading</option>
                      <option selected></option>
                      <option value="small">Small</option>
                    </select>
                    <select class="ql-font"><option selected="">Sans Serif</option><option value="serif">Serif</option><option
                      value="monospace">Monospace</option></select>
                  </span>
                            <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                    <button class="ql-strike" aria-label="Strike"></button>
                  </span>
                            <span class="ql-formats">
                    <select class="ql-color"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                    <select class="ql-background"><option selected="selected"></option><option value="#e60000"></option><option
                      value="#ff9900"></option><option value="#ffff00"></option><option value="#008a00"></option><option
                      value="#0066cc"></option><option value="#9933ff"></option><option value="#ffffff"></option><option
                      value="#facccc"></option><option value="#ffebcc"></option><option value="#ffffcc"></option><option
                      value="#cce8cc"></option><option value="#cce0f5"></option><option value="#ebd6ff"></option><option
                      value="#bbbbbb"></option><option value="#f06666"></option><option value="#ffc266"></option><option
                      value="#ffff66"></option><option value="#66b966"></option><option value="#66a3e0"></option><option
                      value="#c285ff"></option><option value="#888888"></option><option value="#a10000"></option><option
                      value="#b26b00"></option><option value="#b2b200"></option><option value="#006100"></option><option
                      value="#0047b2"></option><option value="#6b24b2"></option><option value="#444444"></option><option
                      value="#5c0000"></option><option value="#663d00"></option><option value="#666600"></option><option
                      value="#003700"></option><option value="#002966"></option><option
                      value="#3d1466"></option></select>                    <span class="ql-format-separator"></span>
                </span>
                            <span class="ql-formats">
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <select title="Text Alignment" class="ql-align">
                      <option selected>Left</option>
                      <option value="center" label="Center"></option>
                      <option value="right" label="Right"></option>
                      <option value="justify" label="Justify"></option>
                    </select>
                        <button class="ql-indent" value="-1"></button>
                        <button class="ql-indent" value="+1"></button>
                  </span>
                            <span class="ql-formats">
                    <button aria-label="Link" class="ql-link"></button>
                    <button aria-label="Document" style="font-size: 1.3em;margin-top: -3px;" #el
                            (click)="selectDocument(el)">D</button>
                    <button aria-label="Image" class="ql-image"></button>
                    <button aria-label="Code block" class="ql-code-block"></button>
                  </span>
                            <span class="ql-formats">
                    <button aria-label="Clean" class="ql-clean"></button>
                  </span>
                            <!--span class="ql-formats">
                              <button aria-label="" class="pi pi-table better-table"
                                      style="font-family: 'primeicons';"></button>
                            </span-->
                          </p-header>
                        </p-editor>
                      </form>
                      <button mat-button mat-raised-button style="margin: 10px 0 0 0" (click)="save(set, i)">Save
                      </button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </td>
          </tr>
        </ng-template>
      </p-table>

    </div>
  </div>
</div>
